import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AuthPage.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const adminBaseUrl = (process.env.REACT_APP_ADMIN_URL || '').replace(/\/$/, '');
      const response = await fetch(`${adminBaseUrl}/admin-login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('admin_access_token', data.access_token);
        localStorage.setItem('admin_refresh_token', data.refresh_token);
        navigate('/admin-dashboard');
      } else {
        setError(data.error || 'Login failed. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <nav className="auth-nav">
        <Link to="/" className="auth-nav-logo">
          <img
            src="/StratusEdgeFinal_whiteupscaled.png"
            alt="Edge AI"
            className="auth-nav-logo-img"
          />
        </Link>
      </nav>

      <div className="auth-split">
        <div className="auth-split-left">
          <div className="auth-orb auth-orb-1" aria-hidden="true" />
          <div className="auth-orb auth-orb-2" aria-hidden="true" />
          <div className="auth-orb auth-orb-3" aria-hidden="true" />

          <div className="auth-left-main">
            <h1 className="auth-hero">Admin Portal</h1>
            <p className="auth-hero-sub">
              Manage tenants, users, and Oracle knowledge for Edge AI.
            </p>

            <div className="auth-chat-preview" aria-hidden="true">
              <div className="preview-header">
                <div className="preview-dot red" />
                <div className="preview-dot yellow" />
                <div className="preview-dot green" />
                <span className="preview-title">Edge AI Admin</span>
              </div>
              <div className="preview-messages">
                <div className="preview-user-msg">Upload 26A release notes</div>
                <div className="preview-bot-msg">
                  <div className="preview-bot-icon">⬡</div>
                  <div className="preview-bot-text">
                    <strong>12 PDFs ingested</strong> into the shared Oracle knowledge base.
                    <span className="preview-cursor">|</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="auth-split-border" aria-hidden="true" />

        <div className="auth-split-right">
          <div className="auth-form-shell auth-form-animate">
            <h2 className="auth-heading">Welcome back</h2>
            <p className="auth-subheading">Sign in to the admin portal.</p>

            <form className="auth-form" onSubmit={handleLogin}>
              <div className="auth-input-container">
                <label htmlFor="admin-email">Email Address</label>
              </div>
              <input
                id="admin-email"
                type="email"
                placeholder="you@company.com"
                className="auth-input auth-input-lg"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />

              <div className="auth-input-container mt-2">
                <label htmlFor="admin-password">Password</label>
              </div>
              <div className="relative">
                <input
                  id="admin-password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="••••••••"
                  className="auth-input auth-input-lg password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  className="auth-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'} />
                </button>
              </div>

              {error && <p className="auth-inline-error">{error}</p>}

              <button className="auth-button auth-button-primary" disabled={loading}>
                {loading ? (
                  <span className="auth-button-loading">
                    <span className="auth-spinner" aria-hidden="true" />
                    Signing in…
                  </span>
                ) : (
                  'Sign in'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
